
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/UserPage/UserPage",
      function () {
        return require("private-next-pages/users/UserPage/UserPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/UserPage/UserPage"])
      });
    }
  